import sankey from './sankey'

export default { sankey }
